import { apiClient } from "../lib/api-client";

export interface UploadProgress {
  progress: number;
  status: "uploading" | "completed" | "error";
}

export const uploadService = {
  async uploadVideo(
    projectId: string,
    file: File,
    onProgress?: (percent: number) => void
  ): Promise<string> {
    const result = await apiClient.uploadVideoToS3(file, projectId, onProgress);
    return result.data.videoUrl;
  },

  async uploadThumbnail(
    projectId: string,
    file: File,
    onProgress?: (progress: number) => void
  ): Promise<string> {
    const formData = new FormData();
    formData.append("thumbnail", file);

    const response = await apiClient.upload<{ thumbnailUrl: string }>(
      `/upload/projects/${projectId}/thumbnail`,
      formData,
      onProgress
    );

    if (response.success && response.data) {
      return response.data.thumbnailUrl;
    }
    throw new Error(response.message || "Thumbnail upload failed");
  },
};
